"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmittalCapabilities = exports.SpecificSubmittalCapabilities = void 0;
const RfiSubmittalCommonCapabilities_1 = require("../../common/capabilities/RfiSubmittalCommonCapabilities");
var SpecificSubmittalCapabilities;
(function (SpecificSubmittalCapabilities) {
    SpecificSubmittalCapabilities["CanLogRevision"] = "can_log_revision";
})(SpecificSubmittalCapabilities = exports.SpecificSubmittalCapabilities || (exports.SpecificSubmittalCapabilities = {}));
exports.SubmittalCapabilities = Object.assign(Object.assign({}, RfiSubmittalCommonCapabilities_1.RfiSubmittalCommonCapabilities), SpecificSubmittalCapabilities);
//# sourceMappingURL=SubmittalCapabilities.js.map